import {Pipe, PipeTransform} from "@angular/core";
import {LoggerService} from "../../shared/logger.service";
import {Kernrecht} from "./kernrecht.model";

@Pipe({
	name: 'dataPipeKernrecht',
	standalone:true

})
export class DataTablePipeKernrecht implements PipeTransform {
	constructor(private _logger: LoggerService) { }
	transform(array: Kernrecht[], query: string): Kernrecht[] {
		if (query && typeof query === 'string') {
			return array.filter((value: Kernrecht, index: number, arr: Kernrecht[]) =>
				value.sprachschluessel.toLowerCase().indexOf(query.toLowerCase()) > -1
			);
		}
		return array;
	} 
}
